import http from "./httpServices";
import config from "./config.json";
export const getMarketData = () => {
  return http.get(`${config.arzfi}/market/assets`);
};
export const getCoinList = () => {
  return http.get(`${config.arzfi}/market/list`);
};
export const getCoinInfo = async (coin) => {
  try {
    return await http.get(`${config.arzfi}/market/asset/${coin}`);
  } catch (err) {
    if (err.response.status === 404) {
      window.location.replace("/404");
    }
  }
};
export const getNetworkInfo = async (coin) => {
  return http.get(`${config.arzfi}/market/chains/${coin}`);
};

export const getRateOfCoins = (first, second) => {
  return http.get(`${config.arzfi}/market/rate/${first}-${second}`);
};
